import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { getNavigationForRole } from '../config/routes';
import { useUser } from '../hooks/useUser';
import { Loader } from './Loader';

function AppMenu() {
	const user = useUser();
	const location = useLocation();

	if (user.isLoading) {
		return <Loader />;
	}

	const navigationItems = getNavigationForRole(user.role);

	return (
		<List>
			{navigationItems.map(item => {
				const isActive = location.pathname === item.path;
				return (
					<ListItem key={item.label} disablePadding>
						<ListItemButton
							component={Link}
							to={item.path}
							selected={isActive}
							sx={{
								'&.Mui-selected': {
									backgroundColor: 'rgba(255, 255, 255, 0.1)',
									'&:hover': {
										backgroundColor: 'rgba(255, 255, 255, 0.15)',
									},
								},
							}}
						>
							{/* <ListItemIcon>{item.icon}</ListItemIcon> */}
							<ListItemText primary={item.label} />
						</ListItemButton>
					</ListItem>
				);
			})}
		</List>
	);
}

export { AppMenu };
